import auth from "./auth";
import users from "./users";
import reports from "./reports";
import settings from "./settings";

export default {
  auth,
  users,
  reports,
  settings,
  type: 'LIVE'
}